import React from 'react';
import { EdgeProps, EdgeLabelRenderer, BaseEdge, getStraightPath } from '@xyflow/react';

interface CustomEdgeData {
  condition?: string;
  orderIndex?: number;
  isActive?: boolean;
}

export const CustomEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data = {},
  label,
  markerEnd,
  style = {},
}) => {
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const customData = data as CustomEdgeData;

  const edgeStyle = {
    stroke: customData?.isActive ? '#6b7280' : '#d1d5db',
    strokeWidth: 2,
    ...style,
  };

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={edgeStyle}
      />
      {(label || customData?.condition) && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <div className="px-2 py-1 bg-white border border-gray-300 rounded shadow-sm text-xs font-medium">
              {label}
              {customData?.condition && (
                <div className="text-xs text-gray-500 mt-1">
                  {customData.condition}
                </div>
              )}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export const edgeTypes = {
  custom: CustomEdge,
};